import { Component, computed, input } from '@angular/core';
import { ChiaveConfig } from 'src/app/models/configurazioni/ChiaveConfig';
import { AttivitaReale } from 'src/app/models/didattica/attivita-reale';
import { FreqInfo } from 'src/app/models/didattica/frequinfo';
import { StudenteProgress } from 'src/app/models/didattica/studente-progress';
import { StatoPresenza } from 'src/app/models/rilevazione-presenze/presenza';
import { ConfigService } from 'src/app/services/config-service/config-service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
    selector: 'app-progress-bar-studente',
    templateUrl: './progress-bar-studente.component.html',
    styleUrls: ['./progress-bar-studente.component.scss'],
    standalone: false
})
export class ProgressBarStudenteComponent {

  public ar = input<AttivitaReale>();
  public freqVsTotAr = input<boolean>();
  public showAssenze = input<boolean>(true);
  public viewasstudent = input<boolean>();
  public idoneitaMode = input<boolean>();
  public studfreqinfo = input<FreqInfo>();
  public studenteProgress = input<StudenteProgress>();
  
  constructor(
    public utilityService: UtilityService,
    public configService: ConfigService) {
  }

  protected sp = computed<StudenteProgress>(() => {
    const sp: StudenteProgress = {};
    const ar: AttivitaReale = this.ar();
    const freqInfo: FreqInfo = this.studfreqinfo();

    if (this.studenteProgress()) { return this.studenteProgress(); }

    // l'ar viene sempre passata, ma nel caso della visualizzazione lato docente
    // viene passato anche lo studente e le informazioni contenute nell'ar vengono sovrascritte
    if (ar) {
      sp.frequenza = ar.frequenzaStudente(); // % di frequenza dello studente
      if (this.freqVsTotAr()) {
        sp.frequenza = (ar.frequenzaStudente() * ar.totaleMinuti) / (ar.ore * 60); // % di frequenza dello studente
      }

      // sp.frequenza = ar.durataInMinuti / (ar.ore * 60);
      sp.numeropresenze = this.filtraPresenze();  // presenze dello studente
      sp.minutipresenza = ar.durataInMinuti;	 // minuti di presenza dello studente

      sp.numerorilevazioniar = ar.numeroRilevazioni; // numero di rilevazioni totali dell'ar
      sp.minutitotaliar = ar.totaleMinuti;      // totale minuti dell'ar
      sp.minutitotaliarF = ar.totaleMinutiF;      // totale minuti dell'ar
    }

    if (freqInfo) {
      sp.frequenza = freqInfo.frequenza; // % di frequenza dello studente
      sp.numeropresenze = freqInfo.npres;  // presenze dello studente
      sp.minutipresenza = freqInfo.totpres;	 // minuti di presenza dello studente
      sp.numerorilevazioniar = ar.rilevazioni.length;

      if (this.freqVsTotAr()) {
        sp.frequenza = (freqInfo.frequenza * ar.totaleMinuti) / (ar.ore * 60); // % di frequenza dello studente
      }
      // non serve alla visualizzazione docente, ma se dovessero servire...
      // sp.minutitotaliar = ar.totaleMinuti;      // totale minuti dell'ar
    }

    sp.frequenza = Number.isNaN(sp.frequenza)? 0: sp.frequenza;

    sp.minutipresenzaF = this.utilityService.formatDurata(sp.minutipresenza);

    return sp;
  });

  showHint(mess, event) {
    this.utilityService.showHintNoProp(mess, null, event);
  }

  filtraPresenze() {
    let count = 0;

    let abusoAsAssenzaFilter = this.configService.getConfigurazione(ChiaveConfig.ABUSO_AS_ASSENZA_FILTER);
    for (const p of this.ar().presenze) {
      if(abusoAsAssenzaFilter === 'false') {
        if (p.stato === StatoPresenza.PRESENZA || p.stato === StatoPresenza.ABUSO || (p.stato === StatoPresenza.ASSENZA && p.giustificata) ) {
          count++;
        }
      } else {
        if (p.stato === StatoPresenza.PRESENZA || (p.stato === StatoPresenza.ASSENZA && p.giustificata)) {
          count++;
        }
      }
    }
    return count;
  }
}
